<template>
  <div :class="$style.infoTable">
    <div :class="$style.infoTableHeader">
      {{ title }}
    </div>
    <div :class="$style.infoTableBody">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.infoTable {
  border: 1px solid $infoTableBorderColor;
  border-radius: 3px;
  margin-bottom: 20px;
}

.infoTableHeader {
  background-color: $infoTableColor;
  border-bottom: 1px solid $infoTableBorderColor;
  padding: 20px 30px 16px;
  color: $adminPortalTitlesColor;
  font-size: 1.6rem;
}

.infoTableBody {
  padding: 20px 30px;
  background-color: $white-color;

  h6 {
    font-family: $main-font;
    font-size: 1.4rem;
    font-style: normal;
    color: $adminPortalTitlesColor;
  }

  p {
    font-size: 1.2rem;
    color: $adminPortalTextColor;
  }
}
</style>
